﻿/* globals  uetq */
var jquery = require('jquery');
var HabEvents = require("../../Global/habitaclia-events");


(function () {
    "use strict";

    var BingUET = function () {
        __IncludeConversionTag();
        __registerBingUETEvents.call(this);
    };

    var __IncludeConversionTag = function () {
    	var script = document.createElement("script");
    	script.text = '(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"5217760"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.defer=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");';
    	document.body.appendChild(script);
    };

    var __registerBingUETEvents = function () {
    	jquery.subscribe(HabEvents.EventsEnum.ConfirmacionSolicitudEnviada, function () {
        	uetq.push({ 'ec':'', 'ea':'solicitud', 'el':'', 'ev': 1, 'gv': 1});
        });
    };

    BingUET.prototype = {
        constructor: BingUET
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = new BingUET();
    }
    else {
        window.BingUET = new BingUET();
    }



}());